<script setup lang="ts">
import { computed } from 'vue';
import { ONEWAY } from '@/constants';
import DatePicker from 'primevue/datepicker';
import Fluid from 'primevue/fluid';
import InputText from 'primevue/inputtext';

interface Props {
  optionAir: any;
  maxDateRangeValue: any;
  minDateRangeValue: any;
  isReturnDate: any;
  isShowError: boolean;
  disableDate: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{
  'update:optionAir': [value: any];
  'update:maxDateRangeValue': [value: any];
  'update:minDateRangeValue': [value: any];
  'update:isReturnDate': [value: any];
  'update:isShowError': [value: boolean];
  'update:disableDate': [value: boolean];
  changeDateRange: [];
}>();

const option = computed({
  get() {
    return props.optionAir;
  },
  set(value) {
    emits('update:optionAir', value);
  }
});

const onChangeDateRange = () => {
  emits('changeDateRange');
};
</script>
<template>
  <div class="air-calendar-duration grid">
    <div class="col-12 sm:col-6">
      <Fluid>
        <div v-if="option.tripTypeSelected === ONEWAY" class="field departure-date">
          <label for="dept-date">{{ $t('create_quote.departure_date') }}</label>
          <DatePicker
            id="dept-date"
            v-model="option.depDate"
            :maxDate="maxDateRangeValue"
            :minDate="minDateRangeValue"
            dateFormat="dd-M-yy"
            :class="isShowError && !option.depDate ? 'p-invalid' : ''"
            :selectOtherMonths="true"
            :placeholder="$t('common.date_format')"
            :disabled="!disableDate"
          />
          <span class="text-red-500" v-if="isShowError && !option.depDate"> {{ $t('validate.required') }} </span>
        </div>
        <div v-else class="field date-range">
          <label for="dest">{{ $t('advance_quote.form.date_range') }}</label>
          <DatePicker
            v-model="option.dateRange"
            selectionMode="range"
            :maxDate="maxDateRangeValue"
            :minDate="minDateRangeValue"
            dateFormat="dd-M-yy"
            :class="isShowError && !option.dateRange ? 'p-invalid' : ''"
            :selectOtherMonths="true"
            @update:modelValue="onChangeDateRange()"
            :placeholder="$t('common.date_format_range')"
            :disabled="!disableDate"
            id="dept-date-range"
          />
          <span class="text-red-500" v-if="isShowError && (!option.dateRange || !option.dateRange.length)"> {{ $t('validate.required') }} </span>
          <br />
          <span class="text-red-500" v-if="isReturnDate"> {{ $t('create_quote.required_return_date') }} </span>
        </div>
      </Fluid>
    </div>
    <div class="col-12 sm:col-6">
      <Fluid>
        <div class="field duration">
          <label for="duration" v-tooltip.top="$t('advance_quote.form.duration')">{{ $t('advance_quote.form.duration') }}</label>
          <InputText id="air-duration" v-model="option.duration" :disabled="true" :placeholder="$t('advance_quote.form.duration')" />
        </div>
      </Fluid>
    </div>
  </div>
</template>
